var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 102,
    viewBox: "0 0 103 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2325_532)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.3494,
    y: 14.3752,
    width: 62.7002,
    height: 62.7002,
    rx: 26.1251,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.7183,
    y: 27.4379,
    width: 33.9626,
    height: 33.9626,
    fill: "url(#pattern0_2325_532)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2325_532",
    x: 0.755539,
    y: 0.00643826,
    width: 101.888,
    height: 101.888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.22502
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.79691
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.847059 0 0 0 0 0.823529 0 0 0 0 0.988235 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2325_532"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2325_532",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2325_532",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2325_532",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2325_532",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABDNJREFUWEftl11oHFUUx/9ndtukTQSLH2nS7u602p21WKuUYqPGxoaW7GwaiyIR31IRiahIoSD4UAVBxYIvYkFb64tS7EtpMrMYtEb8aA0YRSzZ2RLTmY0piClCbLTJ7j0yszN2s01nJps8emFhmD3nf35zz5lz7hAWuZKJTpU48hTADwJoBnAFwK8E1oWIvJ+fGPhtMZIU1viOlj2xaDT6MYA2H58ZgF8zrOzbADiMdiiA1Do1yRF8BWBtGFEARw1LfyaMbSDAtpa9q/+KlkYAKNcE+TQzjiMSzUlCNIDwCDO/BGCdZ8OMA/mC/k4QRCCAEsu8AuLXXSFBjKdzBf2jamFZ3ndzHc+eAmOn+990cUXxzrGxwd/9IIIASImnJwBqKYvwW4aVfflGglvimTWz4ByA220bIjqYM7XDNQMkN3RtpZL4yRWYi4rS2vMTn132E0zG1UMEvOranDEsvaNmACWmPgrCKUeA8LNh6luDcqok0rvA9IVrN25Y+saaAZKxdA8RnShvJ77PmfqOIIBUIvMAM3/r2l0yLN1N38KevjWQWp/eyRINufmfMqzGJuBkyQ9Ciam9IHzo+owYVnZbzTuw+bb2xtKq1VMAVtoiArT7gqV9HgCgg5B2Spbp3XxBe6FmANsxGVf7Cehyn+isYTW23WgXkrFMGxHbDau8s0S7DFP7cokAnQ8RpK89EfepXqxutZvimY0S2E5XzLUdNiz9/qCaCeoDjr8SyxwD8X5PjAANoEM5SxtRlO5G/qfYQ4w3ANzq2sxKJLWOmgN2B/VdoQDKtbBqEKDWKrWrAOqq7gkmPJs39aNBwZ0shTFydkHpvgl/F+1puNfHZxrEfYaZte1CrdAAnloqoT7Ogp8H0cMAJPf+ZRBOFOeKb45NDhZCRXaNFg3gictye30d1SdQXDltFE5fCjv/q+F8Ae7e0N10lYvNEOQV12IeDpD4DxEpTvpNxOsA7mna0zBbv6IPzL0MbF5cxIWtGXReInG8YS565IfJ/plKq3kAqfXqFpac4eM7QJYANSYx7RstaL9UvNLly3IjEcMA3VIVwB6/f9YYdA0A+1exeAoU3W6Y/ePzXkMlnv6u4j0vAXxYitCR0XHdrDG445aSO2UW0nMADgCIlLXoG8PSnMOtk4K74upuAQy6gRigHsPSTi4lcLVvMpZ5kog/uTYnuMMws2ccACWReQ/MffY1AwN5S/drNjVzKfGMBrDqxHEnZRkgrg4D2O5sCaN3oUNnzVErHJVEej+YjpUBcC5f0Fs9ALsgZAdAcHtuImuP1GVfKbmrnYXwxrNzXPMA7E7mfHRIEreOXsyeW/bodq3J6R1C0FlX2zmu/Q9wXQ0ICfdduKh73wLLmolNsnqvJPCjKzqvBuwjlv35NdRszTw2hKHiskb+T+yJSDJ25VMidDD4YN7KfvAv1TOdMGeT71kAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.440a61068364f4955facc895da8cac09.svg";
export { ForwardRef as ReactComponent };